export default {
    scale: 0.4,
};
